exports.currency = {
  USD: "$",
  INR: "₹",
  AED: "د.إ",
  ZAR: "R",
}
